module.exports = __webpack_public_path__ + "static/media/gb-sct.1225e699.svg";